import type { GlobalStateMergedState } from 'components/GlobalState/GlobalStateModel';

export const selectLoadedInitialAppData = (
  s: GlobalStateMergedState,
): boolean => s.oas !== null;
